import React from 'react'
import styles from './Tile.module.css'

type TileProps = {
    children: React.ReactNode;
    compact?: boolean;
}


const Tile = ({ children, compact }: TileProps) => {
  return (
    <div className={styles.container} style={compact ? { flex: 'unset' } : {}}>
        {children}
    </div>
  )
}

export default Tile